import { Routes, Route } from "react-router-dom";
import HomePage from "./home_page";
import LinkedEventsPage from "./linked_events_page";
import CreateEventPage from "./create_event_page";
import AdminDashboard from "./AdminDashboard";
import PageWithBack from "./PageWithBack";
import EnterLink from "./EnterLink";
import QrGenerator from "./QrGenerator";

export default function App() {
  return (
    <Routes>
      <Route path="/admin/1234" element={<HomePage />} />
      <Route path="/EnterLink" element={<PageWithBack><EnterLink/></PageWithBack>} />
      <Route path="/linked-events" element={<PageWithBack><LinkedEventsPage /></PageWithBack>} />
      <Route path="/create-event" element={<PageWithBack><CreateEventPage /></PageWithBack>} />
      <Route path="/event-details" element={<PageWithBack><div>Event Details Page</div></PageWithBack>} />
      <Route path="/dashboard/:orgId" element={<PageWithBack><AdminDashboard /></PageWithBack>} />
      <Route path="/QrGenerator/:orgId" element={<PageWithBack><QrGenerator /></PageWithBack>} />
    </Routes>
  );
}
